import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { recoilPersist } from 'recoil-persist';

export type StandPickerCameraViewType = 'top' | 'side';

export const cameraViewTypes: { text: string; value: StandPickerCameraViewType }[] = [
    {
        text: 'Вид сверху',
        value: 'top',
    },
    {
        text: '3D Вид',
        value: 'side',
    },
];

const { persistAtom } = recoilPersist({
    storage: typeof window !== 'undefined' ? localStorage : undefined,
    key: 'recoil-persist-stand-picker-camera-view',
});

const standPickerCameraViewState = atom<StandPickerCameraViewType>({
    key: 'standPickerCameraViewState',
    default: 'side',
    effects: [persistAtom],
});

export const useStandPickerCameraViewValue = () => useRecoilValue(standPickerCameraViewState);
export const useSetStandPickerCameraViewState = () => useSetRecoilState(standPickerCameraViewState);
